export const styles = () => ({
  container: {
    borderBottom: '1px solid #EBEBEF',
    paddingBottom: 32,
    marginBottom: 32,
  },
})
